import * as yup from "yup";
import { NFeCadastroVolumesDto } from "../../NFe.Dto";

export const VolumesSchema = yup.object().shape({
  volume: yup
    .array()
    .max(
      5000,
      "Quantidade de registros de volumes deve ser menor ou igual a 5000."
    )
    .of(
      yup
        .object()
        .shape({
          quantidadeVolumes: yup
            .number()
            .typeError("Informe a quantidade.")
            .required("Quantidade obrigatória.")
            .moreThan(0, "A quantidade de volumes deve ser maior que zero."),

          especie: yup
            .string()
            .trim()
            .max(
              60,
              "A espécie do volume deve possuir no máximo 60 caracteres."
            )
            .required("Informe a espécie."),

          marca: yup
            .string()
            .trim()
            .max(60, "A marca do volume deve possuir no máximo 60 caracteres.")
            .nullable()
            .notRequired(),

          pesoLiquido: yup
            .number()
            .typeError("Informe o peso líquido.")
            .required("Peso líquido obrigatório.")
            .min(0, "O peso líquido não pode ser negativo."),

          pesoBruto: yup
            .number()
            .typeError("Informe o peso bruto.")
            .required("Peso bruto obrigatório.")
            .min(0, "O peso bruto não pode ser negativo."),
        })
        .test(
          "peso-bruto-maior-ou-igual-liquido",
          "O peso bruto deve ser maior ou igual ao peso líquido.",
          function (value) {
            const { pesoLiquido, pesoBruto } = value || {};
            if (pesoLiquido == null || pesoBruto == null) return true;

            if (pesoBruto < pesoLiquido) {
              return this.createError({
                path: `${this.path}.pesoBruto`,
                message:
                  "O peso bruto deve ser maior ou igual ao peso líquido.",
              });
            }

            return true;
          }
        )
    ),
});
